import { Connector } from '@web3-react/types'
import { useCallback } from 'react'
import {
    CONNECT_WALLET_FAILED,
    CONNECT_WALLET_STARTED,
    WALLET_CONNECTED,
} from '../../analytics/events'
import { useAnalytics } from '../../context/useAnalytics'
import { useWalletDialog, WalletView } from '../connectDialog/WalletConnectDialogProvider'
import { useConnectedWallet } from '../ConnectedWalletProvider'
import { getConnection, getConnectionName, getIsMetaMask } from './utils'

export const useConnectWallet = (onConnect?: () => void) => {
    const { trackAnalyticsEvent } = useAnalytics()
    const { setSelectedWallet, updateConnectionError } = useConnectedWallet()
    const { setPendingConnector, setWalletView } = useWalletDialog()

    return useCallback(
        async (connector: Connector) => {
            const connectionType = getConnection(connector).type
            trackAnalyticsEvent(CONNECT_WALLET_STARTED, {
                type: getConnectionName(connectionType, getIsMetaMask()),
            })
            try {
                setWalletView(WalletView.Connecting)
                setPendingConnector(connector)
                updateConnectionError({ connectionType, error: undefined })

                await connector.activate()

                setSelectedWallet(connectionType)
                trackAnalyticsEvent(WALLET_CONNECTED, {
                    type: getConnectionName(connectionType, getIsMetaMask()),
                })
                onConnect?.()
            } catch (error: any) {
                console.debug(`wallet connection error: ${error}`)
                updateConnectionError({ connectionType, error: error.message })

                trackAnalyticsEvent(CONNECT_WALLET_FAILED, {
                    type: getConnectionName(connectionType, getIsMetaMask()),
                    error: error.message,
                })
            }
        },
        [
            onConnect,
            setPendingConnector,
            setSelectedWallet,
            setWalletView,
            trackAnalyticsEvent,
            updateConnectionError,
        ]
    )
}
